import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGardService {
  constructor(private authServ: AuthService, private router: Router) { }

  canActivate(): boolean {
    if (!this.authServ.isAuthenticated()) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }

  canNotActivate(): boolean {
    let user_type = localStorage.getItem('user_type');
    if (this.authServ.isAuthenticated()) {
    if(user_type == 'client'){
      this.router.navigate(['/user/home']);
    }else if(user_type == 'merchant'){
      this.router.navigate(['/merchant/home']);
    }
      return false;
    }
    return true;
  }
}
